import React from "react";
import ObsIframe from "../../../iframe-component/onboarding/ObsIframe";

const Completed = () => {
  return <ObsIframe path="/tasklist/completed-task" />;
};

export default React.memo(Completed);
